import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import DialogContentText from '@material-ui/core/DialogContentText';
import { clearMessageAlertAction } from '../../../actions/general.action';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.statusLicense?.containerMessage?.backgroundColor || '#fff',
    '& .MuiIconButton-root': {
      padding: 0,
    },
  },
  rootTitle: {
    display: 'none',
  },
  dialogAlert: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
    },
  },
  titleAlert: {
    fontFamily: 'Muli, Arial',
    color: theme.alertPopup?.titleAlert?.color || '#000',
    fontWeight: 700,
    fontSize: 20,
    paddingTop: 15,
  },
  closeButton: {
    ...(theme.alertPopup?.iconClose || {}),
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  dialogContent: {
    paddingBottom: 20,
    paddingLeft: 50,
    paddingRight: 50,
    paddingTop: 15,
  },
  ButtonCancel: {
    marginLeft: 15,
    marginRight: 15,
    ...(theme.alertPopup?.buttonCancel || {}),
    fontSize: 14,
    minWidth: 150,
    borderRadius: 10,
  },
  ButtonAccept: {
    ...(theme.alertPopup?.buttonAccept || {}),
    fontSize: 14,
    minWidth: 150,
    borderRadius: 10,
  },
  subMensajeProp: {
    textAlign: 'center',
    color: '#7b7b7b',
    fontSize: '16px',
    fontWeight: 700,
    paddingTop: 10,
  },
  mensajeModalMain: {
    ...(theme.alertPopup?.mensajeModalMain || {}),
  },
  buttonsAlert: {
    marginTop: 25,
    marginBottom: 15,
  },
  tamIcon: {
    transform: 'scale(0.85)',
  },
}));

const AlertConfirmEditCustomer = (props) => {
  const { licenseShowMessageAlert, clearMessageAlert } = props;
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (licenseShowMessageAlert) {
      setIsOpen(true);

      if (licenseShowMessageAlert.autoHideAlert === true) {
        const timer = setTimeout(() => {
          setIsOpen(false);
          clearMessageAlert();
        }, 7000);
        return () => clearTimeout(timer);
      }
    } else {
      setIsOpen(false);
    }
  }, [licenseShowMessageAlert, clearMessageAlert]);

  const handleCloseModal = () => {
    setIsOpen(false);
    clearMessageAlert();
  };

  if (!licenseShowMessageAlert) return null;

  const {
    tittleMsg,
    showTitle = false,
    message,
    subMensaje,
    img,
    showClose = true,
    popupStyle,
    contentStyle,
    styleMessage,
    dialogStyle,
    styleTitle,
    imgStyle,
    styleButtonCancel,
    styleButtonAcept,
    textButtonCancel,
    textButtonAcept,
    isOnlyMessage,
    onCancel,
    handleAccept,
  } = licenseShowMessageAlert;

  const shouldHideTitle = !showTitle || !tittleMsg;

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={isOpen}
      className={classes.dialogAlert}
      PaperProps={{ style: dialogStyle }}
    >
      <DialogTitle className={shouldHideTitle ? classes.rootTitle : classes.root}>
        <Typography align="center" className={classes.titleAlert} style={styleTitle}>
          {tittleMsg}
        </Typography>
        {showClose && (
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleCloseModal}>
            <CloseIcon className={classes.tamIcon} />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent className={`${classes.root} ${classes.dialogContent}`} style={popupStyle}>
        <DialogContentText style={{ textAlign: 'center' }} component="span">
          <Grid container spacing={2} style={contentStyle}>
            {img && (
              <>
                <img src={img} alt="img-popup" style={imgStyle} />
                <br />
              </>
            )}

            {message && (
              <Grid item xs={12} style={styleMessage} className={classes.mensajeModalMain}>
                {message}
              </Grid>
            )}

            {subMensaje && (
              <Grid item xs={12} className={classes.subMensajeProp}>
                {subMensaje}
              </Grid>
            )}
          </Grid>
        </DialogContentText>

        {!isOnlyMessage && (
          <Grid container justifyContent="center" className={classes.buttonsAlert}>
            {onCancel && (
              <Button
                variant="contained"
                onClick={handleCloseModal}
                style={styleButtonCancel}
                className={classes.ButtonCancel}
              >
                {textButtonCancel || 'Cancelar'}
              </Button>
            )}
            <Button
              variant="contained"
              onClick={handleAccept || handleCloseModal}
              style={styleButtonAcept?.minWidth ? styleButtonAcept : { minWidth: '40%' }}
              className={classes.ButtonAccept}
            >
              {textButtonAcept || 'Aceptar'}
            </Button>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  clearMessageAlert: clearMessageAlertAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertConfirmEditCustomer);